<template>
  <body class="difference-body" id="difference">
    <div class="text-wrapper">
      <div class="title">
        How We Make a <br class="hide" />
        <span>Difference</span>
      </div>
      <div class="text">
        Wecobi’s innovative approach allows brands to offload excess inventory
        in a manner that preserves brand value, generates revenue, and minimizes
        environmental impact. Our platform leverages advanced data analytics to
        optimize the redistribution process, ensuring that unsold products find
        new homes rather than ending up in landfills. By converting potential
        waste into <span>free marketing</span> and customer loyalty
        opportunities, Wecobi helps brands achieve their sustainability goals
        without sacrificing profitability.
      </div>
    </div>
    <div class="image-wrapper"></div>
  </body>
</template>

<script>
export default {
  name: "Difference",
};
</script>

<style scoped>
.difference-body {
  width: 100%;
  height: 536px;
  border-radius: 20px;
  display: flex;
  overflow: hidden;
}
.text-wrapper {
  width: 50%;
  height: 100%;
  background: linear-gradient(to left, #000000 0%, #232323 100%);
  padding: 0px 70px 0px 90px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.image-wrapper {
  width: 50%;
  height: 100%;
  background-image: url("../../../assets/sustainability/difference.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.title {
  font-size: 45px;
  font-weight: 600;
  line-height: 1.2;
  color: #ffffff;
}
.text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #ffffff;
}
span {
  color: #f98140;
  font-weight: 700;
}

@media (max-width: 1280px) {
  .title {
    font-size: 40px;
  }
  .text {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .text-wrapper {
    padding: 0px 70px 0px 80px;
    gap: 20px;
  }
  .title {
    font-size: 35px;
  }
}
@media (max-width: 850px) {
  .difference-body {
    flex-direction: column-reverse;
    height: 726px;
  }
  .text-wrapper {
    padding: 0px 60px;
    gap: 20px;
  }
  .text-wrapper,
  .image-wrapper {
    width: 100%;
    height: 50%;
  }
  .hide {
    display: none;
  }
}
@media (max-width: 588px) {
  .difference-body {
    height: 599px;
  }
  .text-wrapper {
    padding: 0px 50px;
    gap: 20px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 431px) {
  .difference-body {
    height: 700px;
  }
  .image-wrapper {
    height: 291px;
  }
  .text-wrapper {
    padding: 0px 40px;
    gap: 20px;
    height: 409px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
}
</style>
